// extracted by mini-css-extract-plugin
export default {"round":"Logo_round__vCe7s","small":"Logo_small__FS67d","medium":"Logo_medium__p0RlN","normal":"Logo_normal__mWzb3","big":"Logo_big__6DomT","oversized":"Logo_oversized__xlJSo"};